import { render } from "./OrdineAsporto.vue?vue&type=template&id=3f71a55d&scoped=true"
import script from "./OrdineAsporto.vue?vue&type=script&lang=js"
export * from "./OrdineAsporto.vue?vue&type=script&lang=js"

import "./OrdineAsporto.vue?vue&type=style&index=0&id=3f71a55d&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f71a55d"]])

export default __exports__